import { render, staticRenderFns } from "./IncidentSummary.vue?vue&type=template&id=5b77b9e4&"
import script from "./IncidentSummary.vue?vue&type=script&lang=ts&"
export * from "./IncidentSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports